import { render, staticRenderFns } from "./LocaleText.vue?vue&type=template&id=3a4e555a&scoped=true&"
import script from "./LocaleText.vue?vue&type=script&lang=js&"
export * from "./LocaleText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a4e555a",
  null
  
)

export default component.exports